import { render, staticRenderFns } from "./PathManagement.vue?vue&type=template&id=c4c2dc38&scoped=true"
import script from "./PathManagement.vue?vue&type=script&lang=js"
export * from "./PathManagement.vue?vue&type=script&lang=js"
import style0 from "./PathManagement.vue?vue&type=style&index=0&id=c4c2dc38&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c2dc38",
  null
  
)

export default component.exports